module.exports = __webpack_public_path__ + "img/maya-icon.c4d20aeb.png";